const footerMenuList = [
  {
    id: 1,
    title: "Platforms",
    diffClass: "md:col-start-7",
    list: [
      {
        id: 1,
        href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
        text: "eBuy",
      },
      {
        id: 2,
        href: "https://play.google.com/store/apps/details?id=com.kavanatech.debo",
        text: "Debo",
      },
      {
        id: 3,
        href: "https://play.google.com/store/apps/details?id=com.kavanatech.HuluTender",
        text: "Hulu Tender",
      },
      {
        id: 4,
        href: "https://play.google.com/store/apps/details?id=com.kavanatech.viva_sounds",
        text: "Viva Sounds",
      },
      {
        id: 5,
        href: "https://play.google.com/store/apps/details?id=com.kavanatech.vivaPassenger",
        text: "Viva Meter Taxi",
      },
    ],
  },
  {
    id: 2,
    title: "Company",
    diffClass: "",
    list: [
      {
        id: 1,
        href: "#",
        text: "Home",
      },
      {
        id: 2,
        href: "/blog",
        text: "Our Blog",
      },
      {
        id: 3,
        href: "/careers",
        text: "Careers",
      },
      {
        id: 4,
        href: "/contact",
        text: "Contact Us",
      },
    ],
  },
  {
    id: 3,
    title: "Services",
    diffClass: "",
    list: [
      {
        id: 1,
        href: "#",
        text: "Product Development",
      },
      {
        id: 2,
        href: "#",
        text: "Business Automation",
      },
      {
        id: 3,
        href: "#",
        text: "ICT Consultancy",
      },
      {
        id: 4,
        href: "#",
        text: "ERP provisioning",
      },
      {
        id: 5,
        href: "#",
        text: "AI Automation",
      },
    ],
  },
];

const socialIcons = [
  {
    id: 1,
    href: "https://www.facebook.com/eBuy",
    text: "facebook",
  },
  {
    id: 2,
    href: "https://www.twitter.com/kavanatech",
    text: "twitter",
  },
  // {
  //   id: 3,
  //   href: "https://www.discord.com/kavanatech",
  //   text: "discord",
  // },
  {
    id: 4,
    href: "https://www.instagram.com/kavanatech",
    text: "instagram",
  },
  {
    id: 5,
    href: "https://www.tiktok.com/kavanatech",
    text: "tiktok",
  },
  {
    id: 6,
    href: "https://www.linkedin.com/company/11449591",
    text: "linkedin",
  },
];

export { footerMenuList, socialIcons };
